import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";


export default function PrivacyPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
        <Helmet>
                <title>Privacy - Equibre</title>
                <meta name="description" content="We're commited to keep you safe & secure." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Privacy</h1>
                    <p>Commited to keep it secure.</p>
                </div>
            </section>
            <section className="privacy-section">
                <div className="inner">
                    <div className="content">
                        <p className="mb-4">
                            Equibre ("we," "us," or "our") is committed to protecting your
                            privacy. This Privacy Policy outlines how we collect, use, and
                            safeguard the personal information you provide on our website.
                        </p>
                        <h3 className="mb-2">Information We Collect</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Personal Information:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        You may required to enter some details on our platform to
                                        have access to some services. By entering, we collect some
                                        of your personal required information like name and email,
                                        and we are committed to keeping it private and safe.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Google Analytics:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        We use Google Analytics to collect anonymous data about the
                                        usage of our website, including pages visited, time spent on
                                        the site, and other general information. Google Analytics
                                        uses cookies to gather this data.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Mixpanel:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        Mixpanel helps us analyze user behavior and improve the user
                                        experience. It may collect information such as device
                                        information, IP addresses, and usage patterns. Mixpanel also
                                        uses cookies to track user interactions.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Form Submissions:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        When you voluntarily submit the contact form on our website,
                                        we collect the information you provide, including your name
                                        and email address. Providing your name is optional.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">How We Use Your Information</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Google Analytics and Mixpanel:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        The information collected through Google Analytics and
                                        Mixpanel is used to analyze website traffic, track user
                                        engagement, and improve our website's functionality and
                                        content.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-4">
                                <p className="mb-2">
                                    <strong>Form Submissions:</strong>
                                </p>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        The information submitted via the contact form is used to
                                        respond to your inquiries, provide updates, and deliver
                                        relevant content to you.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">Cookies</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <strong>Google Analytics and Mixpanel Cookies:</strong>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        Cookies are small text files placed on your device to
                                        collect standard internet log information and visitor
                                        behavior information. You can set your browser not to accept
                                        cookies or to indicate when a cookie is being sent.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">Data Sharing</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <strong>Third-Party Services:</strong>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        We may share your information with third-party service
                                        providers, such as Google Analytics and Mixpanel, for the
                                        purposes mentioned above. These providers have their own
                                        privacy policies.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">Your Choices</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <strong>Opt-Out:</strong>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        You can opt-out of Google Analytics tracking by using the
                                        Google Analytics Opt-out Browser Add-on, available at{" "}
                                        <a
                                            href="https://tools.google.com/dlpage/gaoptout"
                                            target="_new"
                                            className="normal-link"
                                        >
                                            https://tools.google.com/dlpage/gaoptout
                                        </a>
                                        .
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">Data Security</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <strong>Security Measures:</strong>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        We implement reasonable security measures to protect against
                                        unauthorized access, alteration, disclosure, or destruction
                                        of your personal information.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <h3 className="mb-2">Changes to This Privacy Policy</h3>
                        <ol className="list-decimal ml-6 mb-6">
                            <li className="mb-4">
                                <strong>Updates:</strong>
                                <ul className="list-disc ml-6">
                                    <li className="mb-2">
                                        We may update this Privacy Policy to reflect changes in our
                                        practices or for other operational, legal, or regulatory
                                        reasons. Any changes will be posted on this page.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        <p>
                            If you have any questions about this Privacy Policy, please
                            contact us at{" "}
                            <a href="mailto:support@equibre.com" className="normal-link">
                                support@equibre.com
                            </a>
                            .
                        </p>
                        <div style={{width: '100%', height: 80}}></div>
                    </div>
                </div>
            </section>
            <ContactListSection />
        </>
    );
}